module.exports = __webpack_public_path__ + "img/onboarding2.e448658b.png";